export class ShareArgs {

  constructor(public url: string,
    public title?: string,
    public image?: string,
    public description?: string,
    public via?: string,
    public tags?: string) {

  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/social-share/shared/share-args.ts